import { atom } from "recoil";

export const affiliateCode = atom<string>({
  key: "affiliateCode",
  default: "",
});
